<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.salesDetails.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headright">
                    <el-date-picker v-model="query.daterange" type="daterange" align="right" unlink-panels :range-separator="$t('pages.salesDetails.rangeSeparator')" :start-placeholder="$t('pages.salesDetails.startDate')" :end-placeholder="$t('pages.salesDetails.endDate')" :picker-options="pickerOptions" class="handle-select mr10" style="width:300px;"></el-date-picker>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.salesDetails.search')}}</el-button>
                </div>
            </div>
            <el-table :data="frequencys" border class="table" ref="multipleTable" :element-loading-text="$t('pages.salesDetails.loading')" v-loading="loading" header-cell-class-name="table-header">
                <el-table-column type="index" width="50" :label="$t('pages.salesDetails.index')"></el-table-column>
                <el-table-column sortable prop="modifyDate" :label="$t('pages.salesDetails.operateTime')" width="150">
                    <template slot-scope="scope">
                        <i class="el-icon-time"></i>
                        {{ scope.row.date | formateData }}
                    </template>
                </el-table-column>
                <el-table-column sortable prop="tare" :label="$t('pages.salesDetails.tare')" width="100"></el-table-column>
                <el-table-column sortable prop="tonnagePound" :label="$t('pages.salesDetails.tonnagePound')" width="105"></el-table-column>
                <el-table-column prop="buyerName" :label="$t('pages.salesDetails.buyerName')" width="280"></el-table-column>
                <el-table-column prop="carNum" :label="$t('pages.salesDetails.carNum')" width="80"></el-table-column>
                <el-table-column prop="driver" :label="$t('pages.salesDetails.driver')" width="80"></el-table-column>
                <el-table-column prop="carrier" :label="$t('pages.salesDetails.carrier')"></el-table-column>
                <el-table-column prop="weighman" :label="$t('pages.salesDetails.weighman')" width="80"></el-table-column>
                <el-table-column prop="carNumColor" :label="$t('pages.salesDetails.carNumColor')" width="80"></el-table-column>
                <el-table-column prop="carType" :label="$t('pages.salesDetails.carType')" width="80"></el-table-column>
                <el-table-column prop="crDirection" :label="$t('pages.salesDetails.crDirection')" width="80"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { dateFormat, SortField } from '../../utils/helper';
let that;
export default {
    name: 'frequency',
    data: function () {
        return {
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                }
            },
            balanceArr: [],
            frequencys: [],
            pageCount: 1,
            multipleSelection: [],
            loading: false,
            query: {
                startDate: '',
                endDate: '',
                daterange: '',
                daterange: '',
                balanceId: 0,
                PageIndex: 1,
                PageSize: 15
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now(); //如果没有后面的-8.64e7就是不可以选择今天的
                },
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    created() {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.query.daterange = [start, end];

        this.getData();
        this.getBalance();
    },

    methods: {
        getData() {
            if (this.query.daterange == null) {
                this.$notify.warning(this.$t('pages.salesDetails.dateRequired'));
                return;
            }
            this.query.startDate = new Date(dateFormat.formatDate(this.query.daterange[0], 'yyyy-MM-dd 08:00:00'));
            this.query.endDate = new Date(dateFormat.formatDate(this.query.daterange[1], 'yyyy-MM-dd 08:00:00'));
            this.$zybhttp
                .post('DataInquiry/GetSalesDetails', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('id', 'desc'));
                        this.frequencys = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.salesDetails.fetchError')));
        },

        getBalance() {
            var serach = {};
            this.$zybhttp
                .post('Balance/GetList', { Field3: '1', Field4: '3' })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = [{ id: 0, name: this.$t('pages.salesDetails.all') }].concat(d).sort(SortField('id', 'asc'));
                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.salesDetails.fetchError')));
        },

        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },

        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
